export enum SelectorAccessRightsMode {
  Compact = "compact",
  Detailed = "detailed",
}
